import React from 'react';
import { connect } from 'react-redux';
import { ResourcesItem } from 'redux-and-the-rest';
import { Redirect } from 'react-router-dom';

import { UserModel } from './models/userModel';
import { ApplicationState } from './redux/types';
import { getUser } from './redux/reducers/userReducer';
import { isEducator } from './utils/UserUtils';
import { Routes } from './routes';

interface Props extends React.ComponentProps<'div'> {
   user: ResourcesItem<UserModel>;
}

/**
 * Prevents access to a given component or components based on the presence of User role 'educator'
 */
const EducatorGate = ({
  children,
  user,
}: Props) => {
  if (!isEducator(user)) {
    // Log the User out, they shouldn't be here.
    return <Redirect to={Routes.Session.Destroy} />;
  }

  return (
    <>
      {children}
    </>
  );
};

const mapStateToProps = ({ users }: ApplicationState) => ({
  user: getUser(users),
});

export default connect(mapStateToProps)(EducatorGate);
